(function() {
    angular
        .module('app')
        .directive('gsaResultItem',gsaResultItem);

    function gsaResultItem(){

        return {
            restrict: 'E',
            templateUrl :'app/directives/gsaResultItem/gsaResultItem.html',
            scope: {
                result: '=',
                showItemStats: '=',
                resultTargetWindow: '='
            },
            link: function (scope, el, attrs) {
                scope.showStats = false;
                scope.targetWindow = scope.resultTargetWindow || "";
                scope.displayUrl = formatUrl(scope.result.url);

                function formatUrl(url){
                    var _maxLength = 70;

                    let _url = url.replace(/^https*:\/\//,'')

                    if(_url.length > _maxLength-3){
                        return _url.substring(0,_maxLength)+"...";
                    }
                    return _url;
                }
            }
        }
    }
})();